import {
    Card,
    Form,
    Input,
    Button,
    Space,
    Tooltip,
    message,
    Radio,
    InputNumber
} from 'antd'
import {useEffect, useState} from 'react'
import {
    PlusCircleOutlined,
    ExclamationCircleOutlined
} from '@ant-design/icons'
import useProcurementTypeContext from "../../../Purchase/hooks/useProcurementTypeContext";
import useOperateAddProductList from "../../../Purchase/hooks/useOperateAddProductList";
import service from "../../../../@services";
import NewProductListTable from "../../../../components/NewProductListTable";
import ProductSearchModal from "../../../Product/components/ProductSearchModal";
import TimeDurationFormItem from "../../../../components/TimeDurationFormItem";
import {useLocation} from "react-router-dom";
import QueryString from "qs";

const basicDurationKeys = ['validBeginTime', 'validEndTime']
const { TextArea } = Input;
export default function EditActivityGroup(props) {
    const { search } = useLocation();
    const [storeCode,setStoreCode] = useState('')
    const [loading, setLoading] = useState(false)
    const { isOrder, requestBaseModule } =
        useProcurementTypeContext()
    const [supplierId, setSupplierId] = useState(null)
    const {
        rowKey,
        pageData,
        handleSave,
        deleteRecord,
        getProductInfoBySeachModal,
        list,
        setList,
        setPage
    } = useOperateAddProductList({ supplierId })
    const [showAddProductList, setShowAddProductList] = useState(false)
    const [purchaseValue, setPurchaseValue] = useState(1)
    useEffect(() => {
        let query = QueryString.parse(decodeURIComponent(search.replace("?", "")));
        setStoreCode(query.storeId)
    }, [search]);

    useEffect(() => {
        let newList = list.map((item) => {
            if(item.limitCount){
                item.limitCount = item.limitCount
            }else{
                item.limitCount = -1
            }
            return item
        })
        basicForm.setFieldsValue({
            products: newList
        })
    }, [list]);
    async function confirmAdd() {
        if(!list){
            message.info('请选择商品');
            return
        }
        setLoading(true)
        try {
            await basicForm.validateFields()
            const params = {
                products: list,
                storeCode: storeCode,
                ...basicForm.getFieldsValue()
            }
            const data = await service.activity.createActivityGroup(params)
            if(data){
                props.history.goBack()
                freshList()
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
        }
    }
    const [basicForm] = Form.useForm()
    const actionsFooter = (
        <Form form={basicForm}>
            <Form.Item>
                <Space align='end'>
                    <Button
                        type='primary'
                        loading={loading}
                        htmlType='submit'
                        onClick={confirmAdd}>
                        确认
                    </Button>{' '}
                    <Button onClick={()=>props.history.goBack()}>取消</Button>
                </Space>
            </Form.Item>
        </Form>
    )
    const colums = [
        {
            title: '团购价格',
            dataIndex: 'actPrice',
            isRs: true
        },
        {
            title: '活动库存',
            dataIndex: 'actStock',
            isRs: true
        },
        {
            title: '线上销售库存',
            width: '150px',
            dataIndex: 'saleableStock'
        },
        {
            title:
                <div>
                    最低团购商品数量
                    <Tooltip placement="topLeft" title="活动结束后商品数量未达团购最低数量订单将会自动取消" arrowPointAtCenter>
                        <ExclamationCircleOutlined style={{ marginLeft: '10px' }}/>
                    </Tooltip>
                </div>
            ,
            width: '180px',
            dataIndex: 'minBuy',
            formatter: val => {
                val = val && Math.abs(parseInt(val))
                if (val) {
                    return val
                } else {
                    return ''
                }
            }
        },
        {
            title: '限购规则',
            width: '280px',
            dataIndex: 'limitCount',
            render: (text, record, index) => {
                return (
                    <Radio.Group value={record.purchaseValue} onChange={(e)=>purchaseChange(e, index)}>
                        <Space direction="vertical">
                            <Radio value={1}>不限购</Radio>
                            <Radio value={2}>
                                限购：单笔<InputNumber key={index} min={1} defaultValue={1} disabled={record.purchaseValue === 1 ? true : false} onChange={(e)=>changeLimitCount(e,index)} />件/单
                            </Radio>
                        </Space>
                    </Radio.Group>
                )
            }
        },
        {
            title: '操作',
            fixed: 'right',
            render: (text, record) => (
                <Button size='small' style={{ color: '#d9001b' }} onClick={() => deleteRecord(record)}>
                    删除
                </Button>
            )
        }
    ]

    const changeLimitCount = (e, index) => {
        list[index].limitCount  = e
    }

    const purchaseChange = (e, index)=>{
        list[index].purchaseValue = e.target.value
        const newList = list
        setList([...newList])
        if(e.target.value === 1){
            list[index].limitCount  = -1
        }else {
            if(list[index].limitCount === -1){
                list[index].limitCount = 1
            }
        }
    }

    const openModal = () => {
        // 如果是采购进货不用强制判断是否选择了供应商
        if (supplierId || isOrder) {
            setShowAddProductList(true)
        } else {
            message.info('请选择所属供应商')
        }
    }
    const confirmProductList = async _list => {
        (_list || []).map((item)=>{
            item.purchaseValue = 1
        })
        await getProductInfoBySeachModal(_list)
        setShowAddProductList(false)
    }
    return (
        <Card
            title='创建团购活动'
            className='customer-card'
            actions={[actionsFooter]}>
            <Form
                wrapperCol={{ style: { marginBottom: 20 } }}
                labelCol={{ style: { width: 90, textAlign: 'right' } }}
                form={basicForm}>
                <Form.Item
                    label='活动名称'
                    name='name'
                    rules={[{ required: true, message: '请输入活动名称' }]}>
                    <Input style={{ width: 380 }} maxLength={30} placeholder="请输入活动名称" />
                </Form.Item>
                <TimeDurationFormItem
                    keys={basicDurationKeys}
                    label='活动时间'
                    form={basicForm}
                    isShowTime={true}
                    dateFormatList={'YYYY-MM-DD HH:mm:ss'}
                    isrules={true}
                    isDisableFuture={false}
                    style={{ width: 380 }}
                />
                <Form.Item
                    label='活动说明'
                    name='note'
                    rules={[{ required: true, message: '请输入活动说明' }]}>
                    <TextArea rows={4} maxLength={30} style={{ width: 380 }} placeholder="请输入活动说明（最多30个字）"/>
                </Form.Item>
                <Form.Item
                    label='团购商品'
                    name='products'
                    rules={[{ required: true, message: '请选择团购商品' }]}>
                    <div style={{ margin: '0 0 20px', textAlign: 'left' }}>
                        <Space>
                            <Button
                                type='primary'
                                icon={<PlusCircleOutlined />}
                                onClick={openModal}>
                                选择商品
                            </Button>
                        </Space>
                    </div>
                </Form.Item>
            </Form>
            <div style={{ position: 'relative',top: '-20PX' }}>
                <NewProductListTable
                    otherColumns={colums}
                    isForReturn={!isOrder}
                    pageData={pageData}
                    rowKey={rowKey}
                    handleSave={handleSave}
                    getList={setPage}
                    editList={['actPrice', 'actStock', 'minBuy']}
                />
            </div>
            <Form form={basicForm}  initialValues={{ foreOffShelf: true }}>
                <Form.Item
                    label='商品下架配置'
                    name='foreOffShelf'
                    rules={[{ required: true, message: '请选择商品下架配置' }]}>
                    <Radio.Group>
                        <Radio value={true}>允许</Radio>
                        <Radio value={false}>不允许</Radio>
                    </Radio.Group>
                </Form.Item>
                <div style={{ position: 'relative', color: '#AAAAAA', fontSize: '13px', left: '110px' }}>活动结束后商品强制下架处理</div>
            </Form>
            <ProductSearchModal
                storeCode={storeCode}
                visible={showAddProductList}
                close={() => setShowAddProductList(false)}
                confirmListHaveInfo={confirmProductList}
            />
        </Card>
    )
}

